export const formatDateWithoutOffset = (dateStr: string | null | undefined): string => {
  if (!dateStr || typeof dateStr !== 'string' || !dateStr.trim()) {
    return '';
  }

  let cleanDateStr = dateStr.trim();

  // Si el formato viene con espacio en lugar de "T", lo convertimos a ISO válido
  if (!cleanDateStr.endsWith('Z') && cleanDateStr.includes(' ')) {
    cleanDateStr = cleanDateStr.replace(' ', 'T') + 'Z';
  }

  const date = new Date(cleanDateStr);

  if (isNaN(date.getTime())) {
    return '';
  }

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();

  return `${year}-${month}-${day}`;
};